import { render, staticRenderFns } from "./edit-date.vue?vue&type=template&id=25dbbb96&scoped=true&"
import script from "./edit-date.vue?vue&type=script&lang=js&"
export * from "./edit-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dbbb96",
  null
  
)

export default component.exports